/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OnboardingStateDto
 */
export interface OnboardingStateDto {
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStateDto
     */
    hasInitiatives?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStateDto
     */
    hasMilestones?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStateDto
     */
    hasTasks?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStateDto
     */
    hasBaseline?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStateDto
     */
    hasTeamMembers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStateDto
     */
    hasFirstSnapshot?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OnboardingStateDto
     */
    hasFirstBoardReport?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OnboardingStateDto
     */
    nextCoachingCard?: string;
}

/**
 * Check if a given object implements the OnboardingStateDto interface.
 */
export function instanceOfOnboardingStateDto(value: object): value is OnboardingStateDto {
    return true;
}

export function OnboardingStateDtoFromJSON(json: any): OnboardingStateDto {
    return OnboardingStateDtoFromJSONTyped(json, false);
}

export function OnboardingStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnboardingStateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hasInitiatives': json['hasInitiatives'] == null ? undefined : json['hasInitiatives'],
        'hasMilestones': json['hasMilestones'] == null ? undefined : json['hasMilestones'],
        'hasTasks': json['hasTasks'] == null ? undefined : json['hasTasks'],
        'hasBaseline': json['hasBaseline'] == null ? undefined : json['hasBaseline'],
        'hasTeamMembers': json['hasTeamMembers'] == null ? undefined : json['hasTeamMembers'],
        'hasFirstSnapshot': json['hasFirstSnapshot'] == null ? undefined : json['hasFirstSnapshot'],
        'hasFirstBoardReport': json['hasFirstBoardReport'] == null ? undefined : json['hasFirstBoardReport'],
        'nextCoachingCard': json['nextCoachingCard'] == null ? undefined : json['nextCoachingCard'],
    };
}

export function OnboardingStateDtoToJSON(json: any): OnboardingStateDto {
    return OnboardingStateDtoToJSONTyped(json, false);
}

export function OnboardingStateDtoToJSONTyped(value?: OnboardingStateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasInitiatives': value['hasInitiatives'],
        'hasMilestones': value['hasMilestones'],
        'hasTasks': value['hasTasks'],
        'hasBaseline': value['hasBaseline'],
        'hasTeamMembers': value['hasTeamMembers'],
        'hasFirstSnapshot': value['hasFirstSnapshot'],
        'hasFirstBoardReport': value['hasFirstBoardReport'],
        'nextCoachingCard': value['nextCoachingCard'],
    };
}

